// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_2785","title":"_12150","desc":"_19912","field":"_3349","input":"_8574","action":"_16857","disabled":"_8424","button":"_5712"};